import {MouseEvent} from 'react';
import {
  Alert,
  AlertDescription,
  Button,
  Tabs,
  TabsList,
  TabsTrigger,
  TabsContent,
  useModalControls,
} from '@chekin/guestapp-ui-kit';
import ModalSheet from 'components/common/ModalSheet';
import {AlertCircle, CircleAlert} from 'lucide-react';
import {useTranslation, Trans} from 'react-i18next';
import {DeviceList} from './DeviceList';
import styles from './styles.module.css';

export const DeviceCompatibilityModal = () => {
  const {t} = useTranslation();
  const {
    isOpen: isOpenCheckCompatibility,
    closeModal: closeCheckCompatibility,
    openModal: openCheckCompatibility,
  } = useModalControls();

  const openCheckCompatibilityHandler = (e: MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    openCheckCompatibility();
  };
  return (
    <>
      <Button
        className="flex text-sm font-semibold gap-2 px-0 text-[var(--primary)] hover:text-[var(--primary)]"
        variant="ghost"
        size="sm"
        onClick={openCheckCompatibilityHandler}
      >
        <CircleAlert size={16} />
        {t('esim.choose_plan.device_compatibility.check_compatibility_button')}
      </Button>
      <ModalSheet
        isOpenModalSheet={isOpenCheckCompatibility}
        handleCloseModal={closeCheckCompatibility}
        title={t('esim.choose_plan.device_compatibility.modal_title')}
        withModalMobileCloseButton
        withCloseButton
        closeButtonType="click"
        className={styles.DeviceCompatibilityModal}
      >
        <div className="flex flex-col gap-3">
          <div className="text-base font-semibold">
            {t('esim.choose_plan.device_compatibility.usage_requirements_title')}
          </div>
          <div>
            <Trans i18nKey="esim.choose_plan.device_compatibility.usage_requirements_text" />
            <ul className="list-disc list-inside text-sm leading-6 marker:text-[0.8rem]">
              <li>
                {t('esim.choose_plan.device_compatibility.requirement_supports_esim')}
              </li>
              <li>{t('esim.choose_plan.device_compatibility.requirement_not_locked')}</li>
              <li>
                {t('esim.choose_plan.device_compatibility.requirement_not_jailbroken')}
              </li>
            </ul>
          </div>
        </div>

        <div className="flex flex-col gap-3">
          <div className="text-base font-semibold">
            {t('esim.choose_plan.device_compatibility.devices_title')}
          </div>
          <div>{t('esim.choose_plan.device_compatibility.devices_description')}</div>
          <Alert className="text-[var(--font-secondary)] [--lucide-stroke-width:3]">
            <AlertCircle className="h-4 w-4" size={20} />
            <AlertDescription>
              {t('esim.choose_plan.device_compatibility.device_not_in_list_alert')}
              <ul className="list-disc list-inside text-sm leading-6 marker:text-[0.8rem] pl-2">
                <li>{t('esim.choose_plan.device_compatibility.reason_new_model')}</li>
                <li>
                  {t('esim.choose_plan.device_compatibility.reason_regional_model')}
                </li>
              </ul>
            </AlertDescription>
          </Alert>
        </div>

        <Tabs defaultValue="qr-code" className="w-full">
          <TabsList className="w-full">
            <TabsTrigger value="ios">{t('esim.ios')}</TabsTrigger>
            <TabsTrigger value="android">{t('esim.android')}</TabsTrigger>
          </TabsList>
          <TabsContent value="ios">
            <DeviceList os="ios" />
          </TabsContent>
          <TabsContent value="android">
            <DeviceList os="android" />
          </TabsContent>
        </Tabs>
      </ModalSheet>
    </>
  );
};
